module.exports = __webpack_public_path__ + "static/StatPro-082ba7e74b236fc432ca463a588788e5.png";